module.exports = __webpack_public_path__ + "media/TS_EXPLANATION_ANIMATION.a46b874c.mp4";